

























































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import Constitute from "../../store/entities/booking/constitute";
import Editor from "@tinymce/tinymce-vue";
import TinymceInit from "../../lib/TinymceInit";
import MultiPicture from "../../components/multi-picture.vue";
import RegionSelect from "../../components/region-select.vue";
import Ajax from "../../lib/ajax";
import appconst from "../../lib/appconst";
import { Survey } from "../../lib/tinymce-initial-value";
import CourtSelect from "../../components/court-select.vue";

import { ConstituteDesc } from "../../lib/tinymce-initial-value";
TinymceInit.height = 300;

@Component({
  components: { Editor, RegionSelect, MultiPicture, CourtSelect },
})
export default class EditConstitute extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  constitute: Constitute = new Constitute();

  tinymceInit = TinymceInit;
  constituteDesc = ConstituteDesc;
  supplierList: Array<any> = [];

  get extData() {
    return {
      constituteId: this.constitute.id,
    };
  }

  payMethods: Array<any> = [];

  onConstituteImageDeleted(id) {
    Ajax.delete("/api/services/app/ConstituteImage/Delete?id=" + id)
      .then(() => {})
      .catch(() => {
        this.$Message.error("球场图片删除失败");
      });
  }
  /**
   * @description:获取供应商key and value
   */
  async getSupplierList() {
    return await this.$store
      .dispatch({
        type: "supplier/GetAllSupplierListLabelAndValue",
      })
      .then((res) => {
        if (res && res.data && res.data.result) {
          this.supplierList = res.data.result;
        }
      });
  }
  save() {
    (this.$refs.constituteForm as any).validate(async (valid: boolean) => {
      if (valid) {
        //console.log(JSON.stringify(this.constitute));
        await this.$store.dispatch({
          type: "constitute/updateWithImages",
          data: {
            constitute: this.constitute,
            images: this.constitute.constituteImages,
          },
        });
        (this.$refs.constituteForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.constituteForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.getSupplierList();
      this.constitute = Util.extend(
        true,
        {},
        this.$store.state.constitute.editConstitute
      );
    }
  }
  async created() {
    let reponse = await Ajax.get("/api/services/app/Common/GetOfferPayMethod");
    this.payMethods = reponse.data.result;
  }
  validateBond(rule: any, value: any, callback: any) {
    if (
      typeof this.constitute.payMethod != "undefined" &&
      this.constitute.payMethod == 0
    ) {
      if (this.constitute.bond == 0) {
        callback(
          new Error(this.L("FieldIsRequired", undefined, this.L("Bond")))
        );
      }
    }
    callback();
  }
  validateAdvanceCharge(rule: any, value: any, callback: any) {
    if (
      typeof this.constitute.payMethod != "undefined" &&
      this.constitute.payMethod != 0
    ) {
      if (this.constitute.advanceCharge == 0) {
        callback(
          new Error(
            this.L("FieldIsRequired", undefined, this.L("AdvanceCharge"))
          )
        );
      }
    }
    callback();
  }
  validateImages(rule: any, value: any, callback: any) {
    if (!value) {
      callback(
        new Error(
          this.L("UploadIsRequired", undefined, this.L("ConstituteImages"))
        )
      );
    } else if (value.length == 0) {
      callback(
        new Error(
          this.L("UploadIsRequired", undefined, this.L("ConstituteImages"))
        )
      );
    } else {
      callback();
    }
  }
  constituteRule = {
    name: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("ConstituteName")),
        trigger: "blur",
      },
      {
        type: "string",
        max: 256,
        message: this.L(
          "NoMoreThenLength",
          undefined,
          this.L("ConstituteName"),
          "256"
        ),
        trigger: "blur",
      },
    ],
    startDate: [
      {
        required: true,
        message: this.L("SelectIsRequired", undefined, this.L("StartDate")),
        trigger: "change",
      },
    ],
    endDate: [
      {
        required: true,
        message: this.L("SelectIsRequired", undefined, this.L("EndDate")),
        trigger: "change",
      },
    ],
    payMethod: [
      {
        type: "integer",
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("PayMethod")),
        trigger: "change",
      },
    ],
    advanceCharge: [
      {
        validator: this.validateAdvanceCharge,
        trigger: "change",
      },
    ],
    bond: [
      {
        validator: this.validateBond,
        trigger: "change",
      },
    ],
    description: [
      {
        required: true,
        message: this.L(
          "FieldIsRequired",
          undefined,
          this.L("ConstituteDescription")
        ),
        trigger: "blur",
      },
    ],
    priceExplain: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("PriceExplain")),
        trigger: "blur",
      },
    ],
    reserveFlow: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("ReserveFlow")),
        trigger: "blur",
      },
    ],
    reserveNotice: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("ReserveNotice")),
        trigger: "blur",
      },
    ],
    constituteImages: [
      {
        validator: this.validateImages,
      },
    ],
    courtIds: [
      {
        required: true,
        message: this.L("SelectIsRequired", undefined, this.L("Court")),
        trigger: "blur",
      },
    ],
  };
}
